export * from "@/ui/components/form/Password/Password";
export * from "@/ui/components/form/Password/Password.config";
